import { useEffect, useState } from "react";
import api from "@/lib/api";
import {
  BarChart, Bar, ResponsiveContainer, Tooltip, XAxis, YAxis, Cell,
} from "recharts";

const CHART = ["#0f172a", "#f59e0b", "#0ea5e9", "#7c3aed", "#059669", "#e11d48", "#64748b"];

export default function Reports() {
  const [byLifecycle, setByLifecycle] = useState([]);
  const [byBrand, setByBrand] = useState([]);
  const [byCountry, setByCountry] = useState([]);
  useEffect(() => {
    Promise.all([
      api.get("/dashboard/by-lifecycle"),
      api.get("/dashboard/by-brand"),
      api.get("/dashboard/by-country"),
    ]).then(([a, b, c]) => {
      setByLifecycle(a.data.items || []);
      setByBrand(b.data.items || []);
      setByCountry(c.data.items || []);
    });
  }, []);
  return (
    <div className="space-y-6 max-w-[1600px]">
      <div>
        <div className="text-[10px] font-semibold tracking-[0.08em] uppercase text-slate-500">Intelligence</div>
        <h1 className="text-2xl font-heading font-semibold text-slate-900 tracking-tight">Reports & Analytics</h1>
      </div>

      <ChartCard title="Assets by Lifecycle" data={byLifecycle} xKey="state" />
      <ChartCard title="Top Brands" data={byBrand} xKey="brand" />
      <ChartCard title="Assets by Country" data={byCountry} xKey="country" />
    </div>
  );
}

function ChartCard({ title, data, xKey }) {
  return (
    <div className="bg-white border border-slate-200 rounded-md p-4">
      <div className="text-[10px] uppercase tracking-widest text-slate-500 mb-2">{title}</div>
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 32 }}>
            <XAxis dataKey={xKey} tick={{ fontSize: 11, fill: "#64748b" }} angle={-25} textAnchor="end" interval={0} />
            <YAxis tick={{ fontSize: 11, fill: "#64748b" }} />
            <Tooltip contentStyle={{ border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12 }} cursor={{ fill: "rgba(15,23,42,0.04)" }} />
            <Bar dataKey="count" radius={[4, 4, 0, 0]}>
              {data.map((_, i) => <Cell key={i} fill={CHART[i % CHART.length]} />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
